// scheduling/utils/reportLinks.js
// Deep links + date-string helpers shared by the report components (4-Week Lookahead,
// Scheduled vs Actual).
//
// UI TWIN: api/shared/rprsLinks.js gridJobLink builds the same grid link server-side for the
// weekly JM email. Keep the two parameter sets identical.
//
// WHY EVERY GRID PARAM IS NAMED: the grid falls back to the user's SAVED grid state for any
// param that is ABSENT (docs/navigation.md) — a saved zoom of 1 week would hide weeks 2+, a
// saved "My Schedule" dept scope would hide the job. An explicit empty value clears a param.
// ?job= focuses the row + opens the job sidebar past any filter; cq=<client code> keeps the
// job on screen after that focus clears (it clears when a block is clicked, so Back works).
// A PE-closed job can only be focused when it has entries inside the loaded window — the
// grid's job list excludes closed jobs otherwise.

// YMD string math only — new Date('YYYY-MM-DD') parses as UTC and shifts a day in Central.
export const shortDay = (ymd) => (ymd ? `${Number(ymd.slice(5, 7))}/${Number(ymd.slice(8, 10))}` : '—');

/** The Monday on or before a YYYY-MM-DD date. */
export function mondayOf(ymd) {
  const t = Date.parse(`${ymd}T00:00:00Z`);
  const dow = new Date(t).getUTCDay();
  return new Date(t - ((dow + 6) % 7) * 86400000).toISOString().slice(0, 10);
}

/** The caller's local date as YYYY-MM-DD. */
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Open a job in the grid's Jobs view, focused, at `weekStart`, showing `weeks` weeks. */
export function gridJobHref(job, weekStart, weeks) {
  const p = new URLSearchParams({
    view: 'jobs',
    job: String(job.jobId),
    week: weekStart,
    zoom: String(weeks),
    dept: 'all',
    office: 'all',
    hideEmpty: '0',
    cq: job.clientCode || '',
    client: '',
    jobLead: '',
  });
  return `/schedule/grid?${p.toString()}`;
}
